import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { useHistory } from "react-router-dom";
import LineWithDot from "../AdminMentorAction/img/Line wit Dot.svg";
import * as CryptoJS from "crypto-js";
import "../AdminMentorAction/styles.scss";
import Button from "../Button";
import Pagination from "react-js-pagination";
import * as moment from "moment";
import { Country, State } from "country-state-city";
import hashImage from "../../../../../assets/images/hashImage.jpeg";
import AnimeList from "../../StartupDashboard/ViewAllMentorList/AnimeList";
import iconTooltip from "../../../../../assets/svg/dashboard/iconTooltip.svg";
// import { getStepperTooltipData } from "../../AdminDashboard/AdminMentorAction/dependencies/action";
import profile from "../../../../../assets/svg/dashboard/profile-iconRound.svg";
import excelButton from "../../../../../assets/images/maargThemeXls2.png";
import api from "../../../../common/dependencies/utils/Api";
import { PROFILE_KEY } from "../../../../common/constants/actionConstants";
import axios from "axios";

import {
  getAdminMentorRequestList,
  getPredefineOptionsList,
  getCountersList,
  getNamesList,
  getExcelMentor,
  destructNamesList,
} from "../AdminMentorAction/dependencies/action";
import SubmitAction from "../../../SubmitAction";
import { updateApplicationStatus } from "../ViewApplication/dependencies/action";
import Select from "react-select";

// import arrow from "./img/arrow.png";
import {
  DOWNLOAD_EXCEL_MENTOR_REQUEST,
  COUNTER_MENTOR_REQUESTS,
  TABLELIST_MENTOR_REQUESTS,
} from "../../../../common/constants/ApplicationUrl";

const approvalOptions = [
  {
    value: "Approve",
    label: "Approve",
  },
  { value: "Reject", label: "Reject" },
  { value: "Request Info", label: "Request Info" },
];

export const ColumnNameAdmin = [
  {
    value: "sn",
    text: "NO.",
    sort: false,
  },
  {
    value: "mentorName",
    text: "MENTOR NAME",
    sort: true,
  },
  {
    ra3: "dpiitid",
    text: "MENTOR ID",
    sort: true,
  },
  {
    value: "applicationid",
    text: "APPLICATION ID",
    sort: true,
  },
  {
    value: "applicationdate",
    text: "APPLICATION DATE",
    sort: true,
  },
  {
    value: "applicationform",
    text: "APPLICATION FORM",
    sort: false,
  },
  {
    value: "applicationstatus",
    text: "APPLICATION STATUS",
    sort: false,
  },
  {
    value: "comments",
    text: "COMMENTS",
    sort: false,
  },
];
const customStyles = {
  control: (styles) => ({
    ...styles,
    backgroundColor: "white",
    maxWidth: "220px",
    // color: "#333",
    color: "rgb(121, 193, 206)",
    whiteSpace: "nowrap",
    fontSize: "16px",
    position: "relative",
  }),
  menu: (base) => ({
    ...base,
    width: "max-content",
    // minWidth: "100%",
    fontSize: "14px",
  }),
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: isSelected ? "#b499c7" : isFocused ? "#e4d7ee" : "white",
      color: isSelected ? "white" : "black",
      cursor: isDisabled ? "not-allowed" : "default",
      whiteSpace: "nowrap",
      textAlign: "left",
    };
  },
};

const AdminMentorRequest = (props) => {
  class AesUtil {
    constructor(keySize, iterationCount) {
      this.keySize = keySize / 32;
      this.iterationCount = iterationCount;
    }
  
    generateKey = function (salt, passPhrase) {
      let key = CryptoJS.PBKDF2(passPhrase, CryptoJS.enc.Hex.parse(salt), {
        keySize: this.keySize,
        iterations: this.iterationCount,
      });
      return key;
    };
  
    encrypt = function (salt, iv, passPhrase, plainText) {
      let key = this.generateKey(salt, passPhrase);
      let encrypted = CryptoJS.AES.encrypt(plainText, key, {
        iv: CryptoJS.enc.Hex.parse(iv),
      });
      return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
    };
  }
  const html = document.getElementsByTagName("html")[0];
  const {
    updateApplicationStatus,
    getNamesList,
    getNamesListData,
    destructNamesList,
  } = props;
  const [Heading, setHeading] = useState();
  const [InstructionswithRole, setInstructionswithRole] = useState();
  const [SelectPage, setSelectPage] = useState();
  const [activeText, setActiveText] = useState(true);
  const [activeText2, setActiveText2] = useState(false);
  const [activeText3, setActiveText3] = useState(false);
  const [activeText4, setActiveText4] = useState(false);
  const [activeText5, setActiveText5] = useState(false);
  const [activeText6, setActiveText6] = useState(false);
  const [activeText7, setActiveText7] = useState(false);

  const [sortField, setSortField] = useState("fellowName");
  const [sortOder, setSortOrder] = useState("DESC");
  const [approvaloption, setApprovalOption] = useState("");
  const [showSubmitAction, setShowSubmitAction] = useState(false);
  const [action, setAction] = useState();
  const [submitData, setSubmitData] = useState();
  const [activePage, setActivePage] = useState(1);
  const [filterIndustry, setFilterIndustry] = useState("");
  const [filterFunction, setFilterFunction] = useState("");
  const [filterStage, setFilterStage] = useState("");
  const [filterState, setFilterState] = useState("");
  const [filterCountry, setFilterCountry] = useState("");
  const [indexCounter, setIndexCounter] = useState(0);
  const [nameListValue, setNameListValue] = useState([]);
  const [filterName, setFilterName] = useState("");
  const [filterNameValue, setFilterNameValue] = useState("");
  const [mentorrequestcounter, setMentorrequestcounter] = useState();
  // const [mentorRequestListData, setMentorrequestlist] = useState();
  useEffect(() => {
    api
      .POST(COUNTER_MENTOR_REQUESTS, {})

      .then((response) => {
        setMentorrequestcounter(response.data.data);
      })
      .catch((e) => {
        // console.log(e);
      });

    let data = {
      requestedBy: "",
      status: "",
      pageFilter: {
        currentPage: 0,
        pageSize: 10,
        sortField: "id",
        sortOrder: "ASC",
      },
      searchField: null,
      searchKey: null,
      country: "",
    };

    // api
    //   .POST(TABLELIST_MENTOR_REQUESTS, data)

    //   .then((response) => {
    //     setMentorrequestlist(response.data.data);
    //   })
    //   .catch((e) => {
    //   });

    html.style.overflow = "auto";

    localStorage.setItem("mentorRequests", "mentorRequests");

    setTimeout(() => {
      // localStorage.removeItem("activitySummary");
      localStorage.removeItem("allMentorList");
      localStorage.removeItem("allMentorsMentorship");
      localStorage.removeItem("allStartupList");
      localStorage.removeItem("allMentorships");
      localStorage.removeItem("cohortProgram");
      localStorage.removeItem("startupMentorAllMentorships");
      localStorage.removeItem("startUpApplications");
      localStorage.removeItem("cohortApplication");
      localStorage.removeItem("mentorMenu");
    }, 1000);
    let params = {
      listKey: "MentorApplication",
    };
    getNamesList(params);
  }, []);
  useEffect(() => {
    if (getNamesListData !== undefined && getNamesList !== null)
      getNamesListData?.forEach((element, index) => {
        if (index === 0) {
          let arr2 = {
            value: "Select",
            label: "Select Mentor",
          };
          setNameListValue((oldArray) => [...oldArray, arr2]);
        }
        let arr = {
          value: element.id,
          label: element.name,
        };
        if (getNamesListData.length >= nameListValue.length)
          setNameListValue((oldArray) => [...oldArray, arr]);
      });
  }, [getNamesListData]);
  const onclickShowSubmitAction = (action, id, status) => {
    setShowSubmitAction(true);
    setAction(action);
    let params = {
      id: id,
      status: status,
    };
    setSubmitData(params);
  };

  const clickOnClose = () => {
    setShowSubmitAction((x) => !x);
    setShowSubmitAction(!showSubmitAction);
    setApprovalOption("Select");
    localStorage.setItem("mentorRequests", "mentorRequests");
    window.location.reload();
  };

  const defaultFormData = {
    search: "",
    industry: null,
    specialization: null,
    stage: null,
    recognized: "",
    state: "",
    country: "",
  };
  const handlePageChange = (pageNumber) => {
    setActivePage(pageNumber);
    let params = {
      sortKey: "name",
      sortOrder: "ASC",
      country: filterCountry
        ? filterCountry == "Select Country"
          ? ""
          : filterCountry
        : null,
      state: filterState ? (filterState == "select" ? "" : filterState) : null, // optional
      industry: filterIndustry
        ? filterIndustry == "select"
          ? ""
          : filterIndustry
        : null, // optional
      function: filterFunction
        ? filterFunction == "select"
          ? ""
          : filterFunction
        : null, // optional
      stage: filterStage ? (filterStage == "select" ? "" : filterStage) : null, // optional
      // status: status,
      searchField: filterNameValue === "Select" ? "" : filterNameValue,
      status: selectedStatus !== "" ? selectedStatus : "",
      pageFilter: {
        currentPage: pageNumber - 1,
        includeCount: true,
        pageSize: 10,
        sortField: "id",
        sortOrder: "ASC",
      },
    };

    // api
    //   .POST(TABLELIST_MENTOR_REQUESTS, params)

    //   .then((response) => {
    //     setMentorrequestlist(response.data.data);
    //   })
    //   .catch((e) => {
    //   });

    getAdminMentorRequestList(params);
  };
  const defaultFormData2 = {
    search: "",
    industry: "",
    specialization: "",
    stage: "",
    recognized: "",
    state: "",
    country: "",
  };
  const newCountryArray = [];
  const newStateArray = [];
  const [selectedStatus, setSelectedStatus] = useState("");
  const [formData, setFormData] = useState(defaultFormData);
  const [appliedformData, setAppliedFormData] = useState(defaultFormData2);
  const [newCountryOptions, setNewCountryOptions] = useState(newCountryArray);
  const [newStateOptions, setNewStateOptions] = useState(newStateArray);
  const [selectedRow, setSelectedRow] = useState("");

  const [newCountrySelect, setNewCountrySelect] = useState(false);
  const [isShown, setIsShown] = useState(false);
  const setModalIsOpenToTrue = () => {
    setIsShown(!isShown);
  };

  const history = useHistory();
  const {
    getAdminMentorRequestList,
    mentorRequestList,
    totalMentors,
    getPredefineOptionsList,
    getCountersList,
    getCounter,
    getPredefineOptions,
    mentorRequestListPaginatine,
    mentorRequestListData,
    // getStepperTooltipData,
    getStepperData,
    getExcelMentorData,
    getExcelMentor,
  } = props;
  //   useEffect(() => {
  //     getStepperTooltipData();
  //   }, []);
  useEffect(() => {
    setHeading(getStepperData?.Guidedinstructions[0].Heading);
    setInstructionswithRole(
      getStepperData?.Guidedinstructions[0].InstructionswithRole
    );
    setSelectPage(getStepperData?.Guidedinstructions[0].SelectPage);
  }, [getStepperData]);
  useEffect(() => {
    const indDefaultObject = {
      value: "select",
      label: "Select Country",
    };

    const indDefaultObject2 = {
      value: "select",
      label: "Select State",
    };

    Country.getAllCountries().map((item) => {
      const newObject = {
        value: item.isoCode,
        label: item.name,
      };

      newCountryArray.push(newObject);

      setNewCountryOptions(newCountryArray);
    });

    newCountryArray.unshift(indDefaultObject);

    State.getStatesOfCountry(newCountrySelect === true ? "IN" : null).map(
      (item) => {
        const newObject = {
          value: item.name,
          label: item.name,
        };

        newStateArray.push(newObject);

        setNewStateOptions(newStateArray);
      }
    );

    newStateArray.unshift(indDefaultObject2);
  }, [newCountrySelect]);
  useEffect(() => {
    if (localStorage.getItem("showPending")) {
      setActiveText2(true);
      setActiveText(false);
    } else {
      setActiveText(true);
      setActiveText2(false);
    }

    if (localStorage.getItem("showPending")) {
      let params = {
        sortKey: "name",
        sortOrder: "ASC",
        country: formData.country == "Select Country" ? formData.country : null,
        state: formData.state == "select" ? formData.state : null, // optional
        industry: formData.industry == "select" ? "" : formData.industry, // optional
        function: formData.function == "select" ? "" : formData.function, // optional
        stage: formData.stage == "select" ? "" : formData.stage, // optional
        status: "PENDING", // optional
        pageFilter: {
          currentPage: 0,
          includeCount: true,
          pageSize: 10,
          sortField: "id",
          sortOrder: "ASC",
        },
      };

      getAdminMentorRequestList(params);
    } else {
      let params = {
        sortKey: "name",
        sortOrder: "ASC",
        country: formData.country == "Select Country" ? formData.country : null,
        state: formData.state == "select" ? formData.state : null, // optional
        industry: formData.industry == "select" ? "" : formData.industry, // optional
        function: formData.function == "select" ? "" : formData.function, // optional
        stage: formData.stage == "select" ? "" : formData.stage,
        status: selectedStatus ? selectedStatus : null,
        pageFilter: {
          currentPage: 0,
          includeCount: true,
          pageSize: 10,
          sortField: "id",
          sortOrder: "ASC",
        },
        // status: "PENDING", // optional
      };
      // api
      // .POST(TABLELIST_MENTOR_REQUESTS, params)

      // .then((response) => {
      //   setMentorrequestlist(response.data.data);
      // })
      // .catch((e) => {
      // });
      getAdminMentorRequestList(params);
    }

    setTimeout(() => {
      localStorage.removeItem("showPending");
    }, 1000);
  }, []);

  useEffect(() => {
    getPredefineOptionsList();
  }, []);
  useEffect(() => {
    let params = {
      sortKey: "name",
      sortOrder: "ASC",
      country: formData.country,
      state: formData.state, // optional
      industry: formData.industry, // optional
      function: formData.function, // optional
      stage: formData.stage, // optional
      status: selectedStatus ? selectedStatus : null,
    };
    getCountersList(params);
    //
  }, []);
  const sortCloumn = (name) => {
    if (sortField === name) {
      setSortField(name);
      setSortOrder(sortOder === "DESC" ? "ASC" : "DESC");
    } else {
      setSortField(name);
    }
  };

  const getMentorId = (string) => {
    const value = string.substring(string.length - 6);
    return value;
  };
  const getApplicationId = (string) => {
    const value = string.substring(string.length - 6);
    return value;
  };
  const currentRoute = window.location.href;
  let sample;
  sample = currentRoute.slice(0, currentRoute.lastIndexOf("/"));
  const ViewMentorApplicaiton = (applicationId, applicationStatus, index) => {
    setSelectedRow(applicationId);

    let reRoute = window.open(`/view-application/${applicationId}`, "_blank");
    reRoute.id = applicationId;
    reRoute.applicationStatus = applicationStatus;
    reRoute.fromModule = "mentorRequestList";
    reRoute.index = index;
    let pageNo = activePage;
    let testVar = {
      activePage: activePage,
      index: index,
    };
    setIndexCounter(applicationId);
    let timer = setInterval(
      function () {
        if (reRoute.closed) {
          clearInterval(timer);
          let params = {
            sortKey: "name",
            sortOrder: "ASC",
            status: selectedStatus ? selectedStatus : null,
            pageFilter: {
              currentPage: pageNo - 1,
              includeCount: true,
              pageSize: 10,
              sortField: "id",
              sortOrder: "ASC",
            },
          };

          // api
          // .POST(TABLELIST_MENTOR_REQUESTS, params)

          // .then((response) => {
          //   setMentorrequestlist(response.data.data);
          // })
          // .catch((e) => {
          // });
          getAdminMentorRequestList(params);
        }
      },
      [1000]
    );
  };

  const ViewProfile = (item, id) => {
    setSelectedRow(id);

    // let reRoute = window.open(sample + `/mentor-profile/${item}`, "_blank");
    let reRoute = window.open(sample + `/mentor-profile/${encryptAES2(item,PROFILE_KEY)}`, "_blank");
    reRoute.id = item;
  };
  const getMentorApplicationsName = (name) => {
    let params = {
      sortKey: "name",
      sortOrder: "ASC",
      country: filterCountry
        ? filterCountry == "Select Country"
          ? ""
          : filterCountry
        : null,
      state: filterState ? (filterState == "select" ? "" : filterState) : null, // optional
      industry: filterIndustry
        ? filterIndustry == "select"
          ? ""
          : filterIndustry
        : null, // optional
      function: filterFunction
        ? filterFunction == "select"
          ? ""
          : filterFunction
        : null, // optional
      stage: filterStage ? (filterStage == "select" ? "" : filterStage) : null, // optional
      // status: status,
      searchField: name === "Select" ? "" : name,
      pageFilter: {
        currentPage: 0,
        includeCount: true,
        pageSize: 10,
        sortField: "id",
        sortOrder: "ASC",
      },
      status: selectedStatus !== "" ? selectedStatus : "",
    };

    // api
    // .POST(TABLELIST_MENTOR_REQUESTS, params)

    // .then((response) => {
    //   setMentorrequestlist(response.data.data);
    // })
    // .catch((e) => {
    // });
    getAdminMentorRequestList(params);
  };
  const getMentorApplications = (status) => {
    setActivePage(1);
    let params = {
      sortKey: "name",
      sortOrder: "ASC",
      country: filterCountry
        ? filterCountry == "Select Country"
          ? ""
          : filterCountry
        : null,
      state: filterState ? (filterState == "select" ? "" : filterState) : null, // optional
      industry: filterIndustry
        ? filterIndustry == "select"
          ? ""
          : filterIndustry
        : null, // optional
      function: filterFunction
        ? filterFunction == "select"
          ? ""
          : filterFunction
        : null, // optional
      stage: filterStage ? (filterStage == "select" ? "" : filterStage) : null, // optional
      status: status,
      searchField: filterNameValue == "Select" ? "" : filterNameValue,
      pageFilter: {
        currentPage: 0,
        includeCount: true,
        pageSize: 10,
        sortField: "id",
        sortOrder: "ASC",
      },
    };

    // api
    // .POST(TABLELIST_MENTOR_REQUESTS, params)

    // .then((response) => {
    //   setMentorrequestlist(response.data.data);
    // })
    // .catch((e) => {
    // });
    getAdminMentorRequestList(params);
  };
  const handleInputChange = (e, name) => {
    const { value } = e.target;

    setFormData((user) => {
      return { ...user, [name]: value };
    });

    const newFormData = {
      ...formData,
      [name]: value,
    };

    localStorage.setItem("formdata", JSON.stringify(newFormData));

    setAppliedFormData(newFormData);
  };

  const setUpdateApplicationStatus = (action, id, status) => {
    let params = {
      id: id,
      status: status,
      // comments: formData.reason,
    };
    updateApplicationStatus(params).then((res) => {
      if (res) {
        if (res) {
          //
        }
      }
      // onClose();
      localStorage.setItem("mentorRequests", "mentorRequests");
      window.location.reload();
    });
  };
  const getExcelMentorDownload = () => {
    api
      .GET(`${DOWNLOAD_EXCEL_MENTOR_REQUEST}`)
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        let reportDate = moment(new Date()).format("MMM-YYYY");

        link.setAttribute("download", "Mentor Application " + `.xls`);
        document.body.appendChild(link);
        link.click();
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  };

  useEffect(() => {
    window.scrollTo(0, 1);
  }, []);
  useEffect(() => {
    return () => {
      destructNamesList();
    };
  }, []);
  const redirectProfile = (item, id) => {
    setSelectedRow(id);
    let reRoute = window.open(sample + `/startup-profile/${item}`, "_blank");
    reRoute.id = item;
  };
  useEffect(() => {
    return localStorage.removeItem("mentorRequests");
  }, []);
  const encryptAES2 = (text, key) => {
    // let iv = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
    // let salt = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
  
    // let aesUtil = new AesUtil(128, 1000);
    // let ciphertext = aesUtil.encrypt(salt, iv, key, text);
  
    // let aesText = iv + "::" + salt + "::" + ciphertext;
    
    return btoa(text);
  };
  return (
    <>
      <div
        className="mentorapplicationmaindiv"
        style={{
          marginTop: props.location.state?.pageLink ? "100px" : "0px",
        }}
      >
        <div
          className="dashboard-main innermentorappmaindiv"
          style={{ background: "none" }}
        >
          {/* <div className="iconWith-heading">
            <div style={{ width: "100%" }} className="mainhead"></div> */}
          <div className="iconWith-heading admnmentractnappwith">
            <div style={{ width: "100%" }} className="belowappwithnow mainhead">
              <h3
                className="sub-heading2 fadeInDown wow"
                // style={{ color: "#000", fontWeight: 600, fontSize: "28px" }}
              >
                MAARG Portal by Startup India
              </h3>
              <h3 className="dashboard-sub-heading fadeInDown wow">
                ADMIN DASHBOARD: MENTOR REQUESTS
              </h3>
            </div>
            <div className="bothiconadjustment">
              <a href={DOWNLOAD_EXCEL_MENTOR_REQUEST}>
                <div className="newuserTooltip">
                  <img
                    className="excelButton excelbuttonadmindash"
                    src={excelButton}
                    // style={{ top: "2.4rem", width: "47%", left: "3rem" }}
                  ></img>
                  <span
                    className="tooltiptext tooltip-bottom applustar"
                    style={{
                      left: "-46px",
                      top: "2px",
                      width: "143px",
                      height: "46px",
                    }}
                  >
                    Download Excel Report
                  </span>
                </div>
              </a>
              <div
                className="tooltipshow eyeIcon iconitop"
                // style={{    marginTop: "12px"}}
                // onClick={() => {
                //   // html.style.overflow = "hidden";

                //   if (html.style.overflow == "auto") {
                //     html.style.overflow = "hidden";
                //   } else {
                //     html.style.overflow = "auto";
                //   }
                // }}
              >
                <div className="newuserTooltip">
                  <img
                    className="iconbtn top-btn"
                    src={iconTooltip}
                    onClick={() => {
                      setModalIsOpenToTrue();
                      if (html.style.overflow == "auto") {
                        html.style.overflow = "hidden";
                      } else {
                        html.style.overflow = "auto";
                      }
                    }}
                    width={60}
                  />{" "}
                  <span
                    className="tooltiptext tooltip-bottom "
                    style={{ width: "128px", top: "50px", left: "15px" }}
                  >
                    View Instructions
                  </span>
                </div>
              </div>
              {isShown && (
                <div>
                  <AnimeList
                    setModalIsOpenToTrue={setModalIsOpenToTrue}
                    Heading={Heading}
                    InstructionswithRole={InstructionswithRole}
                    SelectPage={SelectPage}
                  />
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="col-md-11 display-center mobileviewcohortappli">
          <div className="admin-bottom-cardNew row mobileviewmentorbelow">
            <div className="col-xs-6 col-sm-6 col-md-2 col-lg-2 mentorAppButton">
              <div className="dashboard-bottom-btn2">
                <p
                  className="text-white2"
                  style={{
                    fontSize: "14px",
                  }}
                >
                  {" "}
                  REQUEST STATUS
                </p>
              </div>
            </div>

            <div
              style={{ paddingLeft: "30px" }}
              className="col-xs-6 col-sm-6 col-md-1 col-lg-1 totalReceivedBlock newuserTooltip mentorapplihead2div"
            >
              <p
                onClick={() => {
                  setActiveText(true);
                  setActiveText2(false);
                  setActiveText3(false);
                  setActiveText4(false);
                  setActiveText5(false);
                  setActiveText6(false);
                  setActiveText7(false);
                  setSelectedStatus("");
                  getMentorApplications("");
                  setActivePage(1);
                }}
                style={{
                  color: activeText ? "#277acc" : "#838186",

                  position: "relative",
                }}
                className="admindasheaderoptions00 applicationHeading9003 specialmetorapplicatinDiv"
              >
                {/* MENTOR REQUEST<br></br> SENT: {getCounter && getCounter.total} */}
                MENTOR REQUEST<br></br> SENT:{" "}
                {mentorrequestcounter && mentorrequestcounter.total}
              </p>
              <span
                className="tooltiptext   tooltip-bottom"
                style={{ left: "-12px", width: "280px" }}
              >
                Click to View Mentor Request Sent Applications
              </span>

              {activeText ? (
                <img
                  className="requestStatusBar statusBarLine03 statusbarxx22"
                  src={LineWithDot}
                />
              ) : (
                ""
              )}
            </div>
            <div
              style={{ left: "-140px" }}
              className="col-xs-6 col-sm-6 col-md-1 col-lg-1 totalPendingBlock newuserTooltip mentorapplihead3div"
            >
              <p
                onClick={() => {
                  setActiveText2(true);
                  setActiveText(false);
                  setActiveText3(false);
                  setActiveText4(false);
                  setActiveText5(false);
                  setActiveText6(false);
                  setActiveText7(false);
                  setSelectedStatus("PENDING");
                  getMentorApplications("PENDING");
                  setActivePage(1);
                }}
                style={{
                  color: activeText2 ? "#277acc" : "#838186",
                  width: "130px",
                }}
                className="admindasheaderoptions00 applicationHeading3 specialmetorapplicatinDiv"
              >
                {" "}
                {/* PENDING <br></br>RESPONSE: {getCounter && getCounter.pending} */}
                PENDING <br></br>RESPONSE:{" "}
                {mentorrequestcounter && mentorrequestcounter.pending}
              </p>
              <span
                className="tooltiptext   tooltip-bottom"
                style={{ left: "32px", width: "300px" }}
              >
                Click to View Pending Response Applications
              </span>
              {activeText2 ? (
                <img
                  className="requestStatusBar positionBar090 statusbarxx22"
                  src={LineWithDot}
                />
              ) : (
                ""
              )}
            </div>
            <div
              style={{ left: "-120px" }}
              className="col-xs-6 col-sm-6 col-md-2 col-lg-2 totalPendingBlock newuserTooltip mentorapplihead4div"
            >
              <p
                onClick={() => {
                  setActiveText2(false);
                  setActiveText(false);
                  setActiveText3(false);
                  setActiveText4(false);
                  setActiveText5(false);
                  setActiveText6(true);
                  setActiveText7(false);
                  setSelectedStatus("ACCEPTED");
                  getMentorApplications("ACCEPTED");
                  setActivePage(1);
                }}
                style={{
                  color: activeText6 ? "#277acc" : "#838186",
                  width: "130px",
                }}
                className="admindasheaderoptions00 applicationHeading2 specialmetorapplicatinDiv"
              >
                {" "}
                {/* ACCEPTED : {getCounter && getCounter.requestInfo} */}
                ACCEPTED :{" "}
                {mentorrequestcounter && mentorrequestcounter.accepted}
              </p>
              <span
                className="tooltiptext   tooltip-bottom"
                style={{ left: "5px", width: "280px" }}
              >
                Click to View Accepted Applications
              </span>
              {activeText6 ? (
                <img
                  className="requestStatusBar statusBarLine03 statusbarxx22"
                  src={LineWithDot}
                />
              ) : (
                ""
              )}
            </div>
            <div
              style={{ left: "-185px" }}
              className="col-xs-6 col-sm-6 col-md-1 col-lg-1 totalPendingBlock newuserTooltip mentorapplihead5div"
            >
              <p
                onClick={() => {
                  setActiveText2(false);
                  setActiveText(false);
                  setActiveText3(false);
                  setActiveText4(false);
                  setActiveText5(false);
                  setActiveText6(false);
                  setActiveText7(true);
                  setSelectedStatus("DECLINED");
                  getMentorApplications("DECLINED");
                  setActivePage(1);
                }}
                style={{
                  color: activeText7 ? "#277acc" : "#838186",
                  textAlign: "left",
                }}
                className="admindasheaderoptions00 applicationHeading2 specialmetorapplicatinDiv"
              >
                {" "}
                {/* DECLINED: {getCounter && getCounter.updatedInfo} */}
                DECLINED:{" "}
                {mentorrequestcounter && mentorrequestcounter.rejected}
              </p>
              <span
                className="tooltiptext  tooltip-bottom"
                style={{ left: "8px", width: "280px" }}
              >
                Click to View Declined Applications
              </span>
              {activeText7 ? (
                <img
                  className="requestStatusBar statusBarLine03 statusbarxx22"
                  src={LineWithDot}
                />
              ) : (
                ""
              )}
            </div>
            {/* <div className="col-xs-6 col-sm-6 col-md-1 col-lg-1 totalPendingBlock2 newuserTooltip mentorapplihead6div">
              <p
                onClick={() => {
                  setActiveText3(true);
                  setActiveText(false);
                  setActiveText2(false);
                  setActiveText4(false);
                  setActiveText5(false);
                  setActiveText6(false);
                  setActiveText7(false);
                  setSelectedStatus("VERIFIED");
                  getMentorApplications("VERIFIED");
                  setActivePage(1);
                }}
                style={{ color: activeText3 ? "#277acc" : "#838186" ,
                textAlign: "center"}}
                className="admindasheaderoptions00 applicationHeading02"
              >
                {" "}
                APPROVED: {getCounter && getCounter.approved}
              </p>
              <span
                className="tooltiptext   tooltip-filterData"
                style={{ left: "-30px", width: "250px" }}
              >
                Click to View Approved Applications
              </span>
              {activeText3 ? (
                <img
                className="requestStatusBar statusBarLine03"
                  src={LineWithDot}
                />
              ) : (
                ""
              )}
            </div>
            <div className="col-xs-6 col-sm-6 col-md-1 col-lg-1 totalPendingBlock3 newuserTooltip mentorapplihead7div">
              <p
                onClick={() => {
                  setActiveText4(true);
                  setActiveText(false);
                  setActiveText2(false);
                  setActiveText3(false);
                  setActiveText5(false);
                  setActiveText6(false);
                  setActiveText7(false);
                  setSelectedStatus("REJECTED");
                  getMentorApplications("REJECTED");
                  setActivePage(1);
                }}
                style={{ color: activeText4 ? "#277acc" : "#838186",
                textAlign: "center" }}
                className="admindasheaderoptions00 applicationHeading02"
              >
                {" "}
                REJECTED: {getCounter && getCounter.rejected}
              </p>
              <span
                className="tooltiptext   tooltip-bottom"
                style={{ left: "-11px", width: "250px" }}
              >
                Click to View Rejected Applications
              </span>
              {activeText4 ? (
                <img
                className="requestStatusBar statusBarLine03"
                  src={LineWithDot}
                />
              ) : (
                ""
              )}
            </div> */}
          </div>
          <div className="filter-row filter-row-common filterDivMentorapp ">
            {/* <div className="container"> */}
            <div>
              <form className="formContainer newfilterdivnow">
                <div className="row desktopFilterRow">
                  <div className="col-11 d-flex justify-content-around">
                    <div className="user-type-dropdown adminfilterdropdown dropDownWidthFix00 newuserTooltip">
                      <Select
                        required={true}
                        id="searchBy"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="searchBy"
                        className="col-12 gendermentorinput"
                        styles={customStyles}
                        value={formData.name}
                        onChange={(e) => {
                          setFormData((user) => {
                            return {
                              ...user,
                              name: e.name == "select" ? null : e,
                            };
                          });
                          setFilterName(e.name);
                          setFilterNameValue(e.value);
                          getMentorApplicationsName(e.value);
                        }}
                        options={nameListValue.length > 0 ? nameListValue : ""}
                        placeholder="Search Mentor"
                      />
                      <span
                        className="tooltiptext tooltip-bottom"
                        style={{ left: "77px", top: "45px", width: "130px" }}
                      >
                        Search Mentor
                      </span>
                    </div>

                    <div className="user-type-dropdown adminfilterdropdown dropDownWidthFix newuserTooltip">
                      <Select
                        required={true}
                        id="Industry"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="industry"
                        className="col-12 gendermentorinput"
                        styles={customStyles}
                        value={formData.industry}
                        onChange={(e) => {
                          setFormData((user) => {
                            return {
                              ...user,
                              industry: e.value == "select" ? null : e,
                            };
                          });
                          setFilterIndustry(e.value);
                        }}
                        options={getPredefineOptions?.industry_options}
                        placeholder="Industry"
                      />
                      <span
                        className="tooltiptext tooltip-bottom"
                        style={{ left: "77px", top: "45px", width: "130px" }}
                      >
                        Search Industry
                      </span>
                    </div>
                    <div className="user-type-dropdown adminfilterdropdown dropDownWidthFix newuserTooltip">
                      <Select
                        required={true}
                        id="specialization"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="specialization"
                        className="col-12 gendermentorinput"
                        styles={customStyles}
                        value={formData.function}
                        onChange={(e) => {
                          setFormData((user) => {
                            return {
                              ...user,
                              function: e.value == "select" ? null : e,
                            };
                          });
                          setFilterFunction(e.value);
                        }}
                        options={getPredefineOptions?._specialisation}
                        placeholder="Function"
                      />
                      <span
                        className="tooltiptext tooltip-bottom"
                        style={{ left: "77px", top: "45px", width: "130px" }}
                      >
                        Search Function
                      </span>
                    </div>

                    <div className="user-type-dropdown adminfilterdropdown dropDownWidthFix newuserTooltip">
                      <Select
                        required={true}
                        id="stage"
                        // label="Gender*"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="stage"
                        className="col-12 gendermentorinput"
                        styles={customStyles}
                        value={formData.stage}
                        onChange={(e) => {
                          setFormData((user) => {
                            return {
                              ...user,
                              stage: e.value == "select" ? null : e,
                            };
                          });
                          setFilterStage(e.value);
                        }}
                        options={getPredefineOptions?.stage_of_startup_options}
                        placeholder="Stage"
                      />
                      <span
                        className="tooltiptext tooltip-bottom"
                        style={{ left: "77px", top: "45px", width: "130px" }}
                      >
                        Search Stage
                      </span>
                    </div>
                    <div className="user-type-dropdown adminfilterdropdown dropDownWidthFix newuserTooltip">
                      <Select
                        required={true}
                        id="country"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="country"
                        className="col-12 gendermentorinput"
                        styles={customStyles}
                        value={formData.country}
                        onChange={(e) => {
                          setFormData((user) => {
                            return {
                              ...user,
                              country: e.value == "select" ? null : e,
                            };
                          });

                          setFilterCountry(e.label);

                          if (e.label === "India") {
                            setNewCountrySelect(true);
                            setFilterState("");
                          } else {
                            setNewCountrySelect(false);
                            setNewStateOptions("");
                            setFilterState("");
                            setFormData((user) => {
                              return {
                                ...user,
                                state: "",
                              };
                            });
                          }
                          setNewStateOptions("");
                        }}
                        options={newCountryOptions}
                        placeholder="Country"
                      />
                      <span
                        className="tooltiptext tooltip-bottom"
                        style={{ left: "77px", top: "45px", width: "130px" }}
                      >
                        Search Country
                      </span>
                    </div>
                    <div className="user-type-dropdown adminfilterdropdown dropDownWidthFix newuserTooltip">
                      <Select
                        required={true}
                        id="state"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="state"
                        className="col-12 gendermentorinput"
                        styles={customStyles}
                        value={formData.state}
                        onChange={(e) => {
                          setFormData((user) => {
                            return {
                              ...user,
                              state: e.value == "select" ? null : e,
                            };
                          });
                          setFilterState(e.value);
                        }}
                        options={newStateOptions}
                        placeholder="State"
                      />
                      <span
                        className="tooltiptext tooltip-bottom"
                        style={{ left: "77px", top: "45px", width: "130px" }}
                      >
                        Search State
                      </span>
                    </div>
                  </div>

                  <div className="col-1 apply-section goButtonFix newuserTooltip">
                    <Button
                      // onClick={handleClickOfFilter}
                      onClick={() => getMentorApplications(selectedStatus)}
                      text="GO"
                      className="filter-button top-btn newcoloredbtn"
                    ></Button>
                    <span
                      className="tooltiptext   tooltip-bottom"
                      style={{
                        left: "46px",
                        width: "126px",
                        height: "48px",
                        top: "42px",
                      }}
                    >
                      Click to Apply Filters
                    </span>
                  </div>
                </div>

                <div className="row mobileFilterRow">
                  <div className="col-11 d-flex justify-content-around mobilefilterunder">
                    <div className="user-type-dropdown col-2 select-box">
                      <Select
                        required={true}
                        id="searchBy"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="searchBy"
                        className="col-12 gendermentorinput input1menappadmndash"
                        styles={customStyles}
                        value={formData.name}
                        onChange={(e) => {
                          setFormData((user) => {
                            return {
                              ...user,
                              name: e.name == "select" ? null : e,
                            };
                          });
                          setFilterName(e.name);
                          setFilterNameValue(e.value);
                          getMentorApplicationsName(e.value);
                        }}
                        options={nameListValue.length > 0 ? nameListValue : ""}
                        placeholder="Search Mentor"
                      />
                    </div>
                    <div className="user-type-dropdown col-2 select-box">
                      <Select
                        required={true}
                        id="Industry"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="industry"
                        className="col-12 gendermentorinput input1menappadmndash"
                        styles={customStyles}
                        value={formData.industry}
                        onChange={(e) => {
                          setFormData((user) => {
                            return {
                              ...user,
                              industry: e.value == "select" ? null : e,
                            };
                          });
                          setFilterIndustry(e.value);
                        }}
                        options={getPredefineOptions?.industry_options}
                        placeholder="Industry"
                      />
                    </div>
                    <div className="user-type-dropdown col-2 select-box">
                      <Select
                        required={true}
                        id="specialization"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="specialization"
                        className="col-12 gendermentorinput input1menappadmndash"
                        styles={customStyles}
                        value={formData.function}
                        onChange={(e) => {
                          setFormData((user) => {
                            return {
                              ...user,
                              function: e.value == "select" ? null : e,
                            };
                          });
                          setFilterFunction(e.value);
                        }}
                        options={getPredefineOptions?._specialisation}
                        placeholder="Function"
                      />
                    </div>

                    <div className="user-type-dropdown col-2 select-box">
                      <Select
                        required={true}
                        id="stage"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="stage"
                        className="col-12 gendermentorinput input1menappadmndash"
                        styles={customStyles}
                        value={formData.stage}
                        onChange={(e) => {
                          setFormData((user) => {
                            return {
                              ...user,
                              stage: e.value == "select" ? null : e,
                            };
                          });
                          setFilterStage(e.value);
                        }}
                        options={getPredefineOptions?.stage_of_startup_options}
                        placeholder="Stage"
                      />
                    </div>
                    <div className="user-type-dropdown col-2 select-box">
                      <Select
                        required={true}
                        id="country"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="country"
                        className="col-12 gendermentorinput input1menappadmndash"
                        styles={customStyles}
                        value={formData.country}
                        onChange={(e) => {
                          setFormData((user) => {
                            return {
                              ...user,
                              country: e.value == "select" ? null : e,
                            };
                          });

                          setFilterCountry(e.label);

                          if (e.label === "India") {
                            setNewCountrySelect(true);
                          } else {
                            setNewCountrySelect(false);
                          }
                          setNewStateOptions("");
                        }}
                        options={newCountryOptions}
                        placeholder="Country"
                      />
                    </div>

                    <div className="user-type-dropdown col-2 select-box">
                      <Select
                        required={true}
                        id="state"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="state"
                        className="col-12 gendermentorinput input1menappadmndash"
                        styles={customStyles}
                        value={formData.state}
                        onChange={(e) => {
                          setFormData((user) => {
                            return {
                              ...user,
                              state: e.value == "select" ? null : e,
                            };
                          });
                          setFilterState(e.value);
                        }}
                        options={newStateOptions}
                        placeholder="State"
                      />
                    </div>
                    <div
                      className="col-md-1 apply-section d-flex justify-content-end"
                      style={{ color: "transparent" }}
                    >
                      <Button
                        className="green-btn filter-btn"
                        onClick={() => getMentorApplications(selectedStatus)}
                        text="Go"
                      />
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>

          <div className="totalTableCount2" style={{ right: "0rem" }}>
            Total Mentors Found: {totalMentors?.paginate?.totalElements} &lt;{" "}
            {mentorRequestListPaginatine?.currentPage} of{" "}
            {mentorRequestListPaginatine?.numPages} &gt;{" "}
          </div>
          {mentorRequestListData && mentorRequestListData?.length > 0 ? (
            <div>
              <div className="table-container2 mt-2">
                <table className="table table-bordered table-admin-mentor">
                  <thead>
                    <tr
                      className="requestheadfont"
                      style={{ textAlign: "center", fontWeight: "600" }}
                    >
                      <th className="tableJustify fixColumbnWidth01">
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "left",
                            alignItems: "center",
                          }}
                        >
                          NO.
                        </div>
                      </th>
                      <th className="tableJustify mentorRequest-01" colspan="2">
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "left",
                            alignItems: "center",
                          }}
                        >
                          MENTOR
                        </div>
                      </th>
                      <th className="tableJustify mentorRequest-02">
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "left",
                            alignItems: "center",
                          }}
                        >
                          MENTOR ID
                        </div>
                      </th>

                      <th className="tableJustify mentorRequest-03">
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "left",
                            alignItems: "center",
                          }}
                        >
                          APPLICATION
                          <br />
                          DATE
                        </div>
                      </th>
                      <th className="tableJustify mentorRequest-04" colspan="2">
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "left",
                            alignItems: "center",
                          }}
                        >
                          REQUEST SENT TO STARTUP
                        </div>
                      </th>
                      {/* <th className="tableJustify fixColumbnWidth4">
                        APPLICATION
                        <br />
                        FORM
                      </th> */}
                      <th className="tableJustify mentorRequest-05">
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "left",
                            alignItems: "center",
                          }}
                        >
                          PURPOSE OF REQUEST
                        </div>
                      </th>
                      <th className="tableJustify mentorRequest-06">
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "left",
                            alignItems: "center",
                          }}
                        >
                          REQUEST
                          <br /> STATUS
                        </div>
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {/* {mentorRequestListData &&
                    mentorRequestListData?.length > 0 ? (
                      mentorRequestListData.map((item, index) => ( */}

                    {mentorRequestListData &&
                    mentorRequestListData?.length > 0 ? (
                      mentorRequestListData.map((item, index) => (
                        <tr
                          key={index}
                          className={
                            item.requestId === indexCounter
                              ? "purpleBackground"
                              : ""
                          }
                          // className={
                          //   item?.mentorRequests[0].id === indexCounter
                          //     ? "purpleBackground"
                          //     : ""
                          // }
                        >
                          {mentorRequestListPaginatine.currentPage === 1 ? (
                            <td>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "left",
                                  // alignItems: "center",
                                  // height: "100px",
                                }}
                                className="serialnodivtable"
                              >
                                {index + 1}
                              </div>
                            </td>
                          ) : (
                            <td>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "left",
                                  alignItems: "center",
                                  height: "100px",
                                }}
                              >
                                {index +
                                  1 +
                                  10 *
                                    (mentorRequestListPaginatine.currentPage -
                                      1)}
                              </div>
                            </td>
                          )}
                          <td
                            style={
                              {
                                // flexDirection: "row",
                                // display: "flex",
                                // justifyContent: "center",
                              }
                            }
                            className="mentornamemaintd"
                          >
                            <div
                              className="newuserTooltip"
                              style={{
                                width: "100px",
                                height: "100px",
                                maxWidth: "none",

                                objectFit: "contain",
                              }}
                            >
                              {/* {item.applicationStatus === "DRAFT" ? (
                                <>
                                  <img
                                    src={
                                      item.mentorRequests[0]
                                        .mentorProfilePic === null
                                        ? hashImage
                                        : item.mentorRequests[0]
                                            .mentorProfilePic
                                    }
                                    className="sidebar-dashboard-icon2"
                                    style={{
                                      width: "100%",
                                      height: "100%",
                                      objectFit: "contain",
                                      cursor: "default",
                                    }}
                                  />
                                  <p className="shownametable">
                                    {item.mentorRequests[0].mentorName}
                                  </p>
                                </>
                              ) : ( */}
                              <>
                                <img
                                  src={
                                    item.mentorRequests[0].mentorProfilePic ===
                                    null
                                      ? hashImage
                                      : item.mentorRequests[0].mentorProfilePic
                                  }
                                  onClick={() => {
                                    setIndexCounter(item.requestId);
                                    ViewProfile(
                                      item?.mentorRequests[0].mentorEmail,
                                      item?.mentorRequests[0].id
                                    );
                                  }}
                                  // src={
                                  //   "https://holmesbuilders.com/wp-content/uploads/2016/12/male-profile-image-placeholder.png"
                                  // }
                                  className="sidebar-dashboard-icon2"
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "contain",
                                    cursor: "pointer",
                                  }}
                                />
                                <p className="shownametable">
                                  {item.mentorRequests[0].mentorName}
                                </p>

                                <div
                                  className="newuserTooltip shownametable"
                                  style={{
                                    cursor: "pointer",
                                    // width: "fit-content",
                                    alignItems: "end",
                                    justifyContent: "flex-end",
                                    height: "fit-content",
                                    width: "100%",
                                    // display: "flex",
                                  }}
                                  onClick={() => {
                                    setIndexCounter(item.requestId);
                                    ViewProfile(
                                      item?.mentorRequests[0].mentorEmail,
                                      item?.mentorRequests[0].id
                                    );
                                  }}
                                >
                                  <img
                                    style={{
                                      height: "46px",
                                    }}
                                    src={profile}
                                  />

                                  <span
                                    className="tooltiptext tooltip-bottom "
                                    style={{
                                      left: "10px",
                                      top: "105px",
                                      width: "150px",
                                    }}
                                  >
                                    View Mentor Profile
                                  </span>
                                </div>
                              </>
                              {/* )} */}
                              {/* {item.applicationStatus === "DRAFT" ? (
                                ""
                              ) : ( */}
                              <span
                                className="tooltiptext tooltip-bottom "
                                style={{
                                  left: "40px",
                                  top: "88px",
                                  width: "150px",
                                }}
                              >
                                View Mentor Profile
                              </span>
                              {/* )} */}
                            </div>
                          </td>
                          <td className="showmentornametd">
                            <div
                              style={{
                                flexDirection: "row",
                                display: "flex",
                                justifyContent: "space-between",
                                height: "100px",
                                width: "100%",
                                // maxWidth: "240px",
                              }}
                            >
                              <div
                                style={{
                                  cursor: "default",
                                  // alignItems: "center",
                                  display: "flex",
                                  width: "80%",
                                  // maxWidth: "240px",
                                  minWidth: "200px",
                                  width: "200px",
                                }}
                                className="row"
                              >
                                <span>{item.mentorRequests[0].mentorName}</span>
                                {/* <span>
                                  {"M" +
                                    getMentorId(
                                      item.mentorRequests[0].mentorId
                                    )}
                                </span> */}
                              </div>

                              {/* {item.applicationStatus === "DRAFT" ? (
                                ""
                              ) : ( */}
                              <div
                                className="newuserTooltip "
                                style={{
                                  cursor: "pointer",
                                  // width: "fit-content",
                                  alignItems: "end",
                                  justifyContent: "center",
                                  height: "100px",
                                  width: "20%",
                                  width: "40px",
                                  display: "flex",
                                }}
                                onClick={() => {
                                  setIndexCounter(item.requestId);
                                  ViewProfile(
                                    item?.mentorRequests[0].mentorEmail,
                                    item?.mentorRequests[0].id
                                  );
                                }}
                              >
                                <img src={profile} style={{ width: "100%" }} />

                                <span
                                  className="tooltiptext tooltip-bottom "
                                  style={{
                                    left: "10px",
                                    top: "105px",
                                    width: "150px",
                                  }}
                                >
                                  View Mentor Profile
                                </span>
                              </div>
                              {/* )} */}
                            </div>
                          </td>
                          <td>
                            {/* {item.applicationStatus === "VERIFIED" ? ( */}
                            <div
                              className="menidmobile meni23mobole"
                              style={{
                                display: "flex",
                                justifyContent: "left",
                                // alignItems: "center",
                                //
                              }}
                            >
                              {"M" +
                                getMentorId(item.mentorRequests[0].mentorId)}
                            </div>
                            {/* ) : (
                              ""
                            )} */}
                          </td>

                          <td>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "left",
                                // alignItems: "center",

                                whiteSpace: "nowrap",
                                fontSize: "15px",
                              }}
                              className="applidatemobile "
                            >
                              {moment(item.applicationDate).format(
                                "DD/MM/YYYY"
                              )}
                              <br />

                              {moment(item.applicationDate).format("hh:mm A")}
                            </div>
                          </td>
                          {/* <div
                              style={{
                                flexDirection: "row",
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                              className="appidmobile andndapo"
                            >
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                               
                                {item?.mentorRequests[0].startupName}
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                               
                                {item?.mentorRequests[0].dpiitNumber}
                              </div>
                              <div
                                className="d-flex justify-content-end newuserTooltip view23applo"
                                style={{
                                  cursor: "pointer",
                                  width: "fit-content",
                                  alignItems: "end",
                                }}
                                onClick={() =>
                                  ViewMentorApplicaiton(
                                    item.id,
                                    item.applicationStatus,
                                    index +
                                      1 +
                                      10 *
                                        (mentorRequestListPaginatine.currentPage -
                                          1)
                                  )
                                }
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="16"
                                  height="16"
                                  fill="currentColor"
                                  className="bi bi-info-circle"
                                  viewBox="0 0 16 16"
                                >
                                  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                  <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z" />
                                </svg>
                                <span
                                  className="tooltiptext tooltip-bottom"
                                  style={{
                                    top: "100px",
                                    left: "12px",
                                    width: "145px",
                                  }}
                                >
                                  View Application
                                </span>
                              </div>
                            </div> */}
                          <td
                            className="strtupapplinametd"
                            style={{
                              justifyContent: "center",
                            }}
                          >
                            <div
                              className="newuserTooltip"
                              style={{
                                width: "100px",
                                height: "100px",
                                maxWidth: "none",
                                objectFit: "contain",
                              }}
                            >
                              <img
                                src={
                                  item.startupImage === null
                                    ? hashImage
                                    : item.startupImage
                                }
                                onClick={() => {
                                  setIndexCounter(item.requestId);
                                  redirectProfile(item.dpiitNo);
                                }}
                                className="sidebar-dashboard-icon2"
                                style={{
                                  width: "100%",
                                  cursor: "pointer",
                                  height: "100%",
                                  objectFit: "contain",
                                }}
                              />
                              <span
                                className="tooltiptext tooltip-bottom "
                                style={{
                                  left: "46px",
                                  top: "88px",
                                  width: "150px",
                                }}
                              >
                                View Startup Profile
                              </span>
                            </div>
                          </td>
                          <td className="d-flex">
                            <div
                              style={{
                                cursor: "default",
                                alignItems: "center",
                                display: "flex",
                                width: "95%",
                                // maxWidth: "240px",
                                // minWidth: "200px",
                              }}
                              className="row"
                            >
                              <span>{item.mentorRequests[0].startupName !== undefined && item.mentorRequests[0].startupName !== null && item.mentorRequests[0].startupName !== "" ? item.mentorRequests[0].startupName : item?.startupName   }</span>
                              <span>{item?.mentorRequests[0].dpiitNumber}</span>
                            </div>
                            <div
                              className="newuserTooltip "
                              style={{
                                cursor: "pointer",
                                // width: "fit-content",
                                alignItems: "end",
                                justifyContent: "center",
                                height: "100px",
                                width: "20%",
                                minWidth: "30px",
                                display: "flex",
                              }}
                              onClick={
                                () => {
                                  setIndexCounter(item.requestId);
                                  redirectProfile(
                                    item?.mentorRequests[0].dpiitNumber
                                  );
                                }
                                // ViewProfile(
                                //   item?.mentorRequests[0].mentorEmail,
                                //   item?.mentorRequests[0].id
                                // )
                              }
                            >
                              <img src={profile} style={{ width: "100%" }} />

                              <span
                                className="tooltiptext tooltip-bottom "
                                style={{
                                  left: "10px",
                                  top: "105px",
                                  width: "150px",
                                }}
                              >
                                View Startup Profile
                              </span>
                            </div>
                          </td>

                          <td className="commentsContent">
                            {item?.mentorRequests[0].purposeOfMentorship
                              ?.length !== undefined &&
                            item?.mentorRequests[0].purposeOfMentorship
                              ?.length > 30 ? (
                              // <td className="commentsContent">
                              <span
                                className=" bigCommentsBox"
                                style={{
                                  lineHeight: "26px",
                                  position: "relative",
                                  top: "0.5rem",
                                }}
                              >
                                {item?.mentorRequests[0].purposeOfMentorship.substring(
                                  0,
                                  54
                                )}
                                <div className="tooltipicon">
                                  <svg
                                    style={{
                                      position: "relative",
                                      cursor: "pointer",
                                      top: "0.1rem",
                                    }}
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="20"
                                    height="20"
                                    fill="currentColor"
                                    class="bi bi-three-dots"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z" />
                                  </svg>

                                  <span
                                    className="tooltiptext61"
                                    style={{
                                      top: "-55px",
                                      left: "200px",
                                    }}
                                  >
                                    <h5 style={{ color: "#fff" }}>Comment</h5>
                                    {
                                      item?.mentorRequests[0]
                                        .purposeOfMentorship
                                    }
                                  </span>
                                </div>
                              </span>
                            ) : (
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  height: "100px",
                                }}
                                className="commentscontentinner"
                              >
                                {item.mentorRequests[0].purposeOfMentorship}
                              </div>
                            )}
                          </td>
                          <td className="applicationStatusMentorapp">
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "left",
                                // alignItems: "center",
                                // height: "100px",
                              }}
                              className="applistatusmobile"
                            >
                              {/* {item.applicationStatus === "VERIFIED" ? (
                                <p className="statusValuementorapp">APPROVED</p>
                              ) : item.applicationStatus === "REJECTED" ? (
                                <p className="statusValuementorapp">REJECTED</p>
                              ) : item.applicationStatus === "DRAFT" ? (
                                <p className="statusValuementorapp">DRAFT</p>
                              ) : item.applicationStatus === "REQUESTINFO" ? (
                                <p className="statusValuementorapp">
                                  REQUESTED INFO
                                </p>
                              ) : (
                                <div
                                  className="rowC newuserTooltip"
                                  style={{ justifyContent: "center" }}
                                >
                                  <Select
                                    required={true}
                                    id="Status"
                                    variant="outlined"
                                    fullWidth
                                    margin="normal"
                                    type="State"
                                    name="Status"
                                    className="col-12 "
                                    styles={customStyles}
                                    isSearchable={false}
                                    // value={filterData6}
                                    onChange={(e) => {
                                      setApprovalOption(e.value);

                                      if (e.value === "Approve") {
                                        setUpdateApplicationStatus(
                                          "Approve",
                                          item.id,
                                          "VERIFIED"
                                        );
                                      } else if (e.value === "Reject") {
                                        onclickShowSubmitAction(
                                          "Reject",
                                          item.id,
                                          "REJECTED"
                                        );
                                      } else if (e.value === "Request Info") {
                                        onclickShowSubmitAction(
                                          "Request Info",
                                          item.id,
                                          "REQUESTINFO"
                                        );
                                      } else {
                                        //
                                      }
                                    }}
                                    options={approvalOptions}
                                    placeholder="Select"
                                  />
                                  <span
                                    className="tooltiptext tooltip-bottom applustar"
                                    style={{
                                      left: "-104px",
                                      top: "-4px",
                                      width: "158px",
                                      height: "46px",
                                    }}
                                  >
                                    Click to Change Application Status
                                  </span>
                                </div>
                              )} */}
                              {item.mentorRequests[0].requestStatus}
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={8} style={{ border: "none" }}>
                          {" "}
                          <div className="no-records">No Records Found</div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
                <div className="pagination-box">
                  {mentorRequestListData && mentorRequestListData.length > 0 ? (
                    <Pagination
                      activePage={activePage}
                      itemsCountPerPage={10}
                      totalItemsCount={
                        mentorRequestListPaginatine.totalElements
                      }
                      pageRangeDisplayed={5}
                      onChange={handlePageChange.bind(this)}
                    />
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          ) : (
            <div className="no-records">No Records Found</div>
          )}
          <div
            className="dashboard-bottom-btn top-btn dashboardbelowBtn newuserTooltip"
            style={{ margin: "auto" }}
            onClick={() => {
              history.push({
                state: {
                  fromModule: "mentorRequests",
                },
              });
              localStorage.setItem("allMentorList", "allMentorList");
              localStorage.removeItem("mentorRequests");
              window.location.reload();
            }}
          >
            <p
              style={{ cursor: "pointer" }}
              className="text-white3 all-viewList"
            >
              VIEW MENTOR LIST
            </p>
            <span
              className="tooltiptext tooltip-bottom"
              style={{ left: "410px", top: "60px", width: "200px" }}
            >
              Click to View Mentor List
            </span>
          </div>
        </div>
        {showSubmitAction ? (
          <SubmitAction
            isOpen={showSubmitAction}
            className={"form-submit-modal"}
            onClose={clickOnClose}
            action={action}
            submitData={submitData}
            formName={"mentor-form"}
          />
        ) : (
          ""
        )}
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    mentorRequestListData: state.AdminMentorReducer.getAdminMentorRequestList,
    totalMentors: state.AdminMentorReducer.getAdminMentorRequestList,
    mentorRequestListPaginatine:
      state.AdminMentorReducer.getAdminMentorRequestList.paginate,
    mentorRequestListData:
      state.AdminMentorReducer.getAdminMentorRequestList?.data,
    getPredefineOptions: state.AdminMentorReducer.getPredefineOptionsList.list,
    getCounter: state.AdminMentorReducer.getCountersList.data,
    updatedStatus: state.AdminMentorViewReducer.updateApplicationStatus.data,
    getNamesListData: state.AdminMentorReducer.getNamesList?.data,
    getStepperData: state.AdminMentorReducer.getStepperList.list,
    getExcelMentorData: state.AdminMentorReducer.getExcelMentor,
  };
};

export default connect(mapStateToProps, {
  getAdminMentorRequestList,
  getPredefineOptionsList,
  getCountersList,
  updateApplicationStatus,
  getNamesList,
  //   getStepperTooltipData,
  getExcelMentor,
  destructNamesList,
})(withRouter(AdminMentorRequest));
